<app-help-page mainVideo="daily-notifications"
               [tutorials]="['daily-notifications', 'breakdown-alert']"
               [videos]="['daily-notifications']"></app-help-page>
